(function () {
  // Cart error message patch — 6 Oct 2026.
  //
  // The theme's Shopify.onError in global.js does two harmful things:
  //   1. It runs eval('(' + responseText + ')'). When Cloudflare returns
  //      an HTML 429 page this throws a SyntaxError and the real error is
  //      lost entirely.
  //   2. It falls back to getInputMessage(parseInt(data-inventory-quantity)),
  //      which yields "You can only add NaN of these products" whenever that
  //      attribute is missing — which is always, for untracked products.
  //
  // Net effect: every failure (429 rate limit, 422 bad variant, 500) showed
  // the same misleading inventory message, which made the Oct 2026 outage
  // take a week to diagnose. This override reports the ACTUAL cause.
  //
  // It also logs status + body to the console so the next incident can be
  // read in seconds rather than reverse-engineered.

  if (window.__rwCartErrorPatch) return;
  window.__rwCartErrorPatch = true;

  var MAX_WAIT_MS = 15000;
  var startedAt = Date.now();

  function friendlyMessage(xhr) {
    var status = xhr ? xhr.status : 0;
    var body = (xhr && xhr.responseText) || '';

    if (status === 429) {
      return 'Too many requests at the moment. Please wait a few seconds and try again.';
    }
    if (status === 0) {
      return 'Connection problem. Please check your internet and try again.';
    }

    // Shopify returns JSON; Cloudflare returns HTML. Only parse JSON.
    var trimmed = body.replace(/^\s+/, '');
    if (trimmed.charAt(0) === '{') {
      try {
        var data = JSON.parse(trimmed);
        if (data.description) return data.description;
        if (data.message) return data.message;
      } catch (e) { /* fall through */ }
    }

    if (status >= 500) {
      return 'The store is having trouble right now. Please try again in a moment.';
    }
    return 'Sorry, we could not add that to your cart. Please try again.';
  }

  function applyPatch() {
    if (!window.Shopify || typeof window.Shopify.onError !== 'function') return false;

    window.Shopify.onError = function (xhr, textStatus, message) {
      var msg = friendlyMessage(xhr);

      try {
        console.error(
          '[rw-cart-error] status=' + (xhr ? xhr.status : 'n/a') +
          ' textStatus=' + textStatus +
          ' body=' + ((xhr && xhr.responseText) || '').slice(0, 400)
        );
      } catch (e) { /* ignore */ }

      if (typeof window.showWarning === 'function') {
        window.showWarning(msg, typeof window.warningTime !== 'undefined' ? window.warningTime : 3000);
      } else {
        console.error('[rw-cart-error] ' + msg);
      }
    };

    return true;
  }

  if (!applyPatch()) {
    var timer = setInterval(function () {
      if (applyPatch() || Date.now() - startedAt > MAX_WAIT_MS) clearInterval(timer);
    }, 100);
  }
})();
